export default function syncableSectionBodyChangeDirective() {
  return {
    template: require('./syncable-section-body-change.html'),
    restrict: 'E',
    controller: 'SyncableSectionBodyChangeController',
    controllerAs: 'syncableSectionBodyChangeVM',
    bindToController: true,
    replace: true,
    scope: {
      change: '=',
      isNew: '=',
      ssTooltipAppendToSelector: '@',
      handleApproveChangeClick: '&',
      handleDenyChangeClick: '&',
      isBatch: '=',
    },
  };
}
